import { connect } from "react-redux";
import OnboardingRequestDetail from "./onboardingRequestDetail";
import { getOnBoardingRequestDetail } from "../../../../../../redux/actions/userManagement/onBoardingRequestDetail.action";
import { clearOnboadingComments, getOnBoardingComments } from "../../../../../../redux/actions/userManagement/onboardingAddComment.action";
import { downloadFiles } from "../../../../../../redux/actions/fileAttachment/fileAttachment.actions";
import { showAlertPopup } from "../../../../../../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import { ReadNotification } from "../../../../../../redux/actions/notification/getEventNotificationList.action";
const mapStateToProps = (state) => {

  return {
    requestDetails : state.onboardingRequest.onBoardingRequestDetail,
    myRights:state.myRights.myRights,
    commentsList :state.onboardingRequest.onBordingCommentList
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
    getOnBoardingRequestDetail: (requestId)=>{
      return dispatch(getOnBoardingRequestDetail(requestId))
    },
    getOnBoardingComments:(requestId,next=null)=>{
      return dispatch(getOnBoardingComments(requestId,next))
    },
    clearOnboadingComments:()=>{
      return dispatch(clearOnboadingComments())
    },
    downloadFiles:(originalFileName,uniqueFileName)=>{
      return dispatch(downloadFiles(originalFileName,uniqueFileName))
  },
  showAlertPopup: (alertHeader,alertmessage) => {
    return dispatch(showAlertPopup(alertHeader,alertmessage))
  },
  ReadNotification: (payload,id) => {
    return dispatch(ReadNotification(payload,id))
  }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingRequestDetail);
